<div class="app-content content">
    <div class="content-wrapper">
        <div class="content-header row mb-1">
            <!-- <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb> -->
        </div>
        <div class="content-body">
            <app-custom-loader-c></app-custom-loader-c>
            <section class="card custom_card_pdf">
                <div id="invoice-template" class="card-body" #invoicetemplate>
                    <!-- Invoice Company Details -->

                    <div id="invoice-company-details" class="row">
                        <div class="custoemPrintFont col-12 text-center">

                            <div>
                                <!-- <h2 class="stripe-1" >INVOICE</h2> -->
                                <a href="http://www.octaitsolution.com/" class="custoemPrintImageWidth"><img class="custoemPrintImageWidth" src="../../../../../assets/custom/images/Octa_Logo1.png" style="width: 19%;float: left;" alt="company logo" /></a>

                                <div class="media-body">
                                    <ul class="ml-2 px-0 list-unstyled">
                                        <div style="float: right;  display:inline;">
                                            <h2 class="textclass" style="color: #078473;
                      font-weight: bold;">Challan</h2>
                                            <span class="custoemPrintFont textclass">
                        # Ch_
                         {{("000"+model.challanNo).slice(-3)}}</span>

                                            <ul class="px-0 list-unstyled">

                                            </ul>
                                        </div>

                                        <li style=" font-size: 1.3rem">
                                            Raghuveer Nagar, Anand Corner Apartment,Wadgaon Sheri, Pune, Maharashtra 411014</li>

                                        <li style="padding-right: 10rem;">Email: <a style="color: blue;font-size:large; ">info@octaitsolution.com</a> Mobile: +91 8686480808</li>

                                        <!-- <li style=" padding-right: 7rem;">Email: <a style="color: blue;font-size:large; ">info@octaitsolution.com</a> Mobile: +91 8686480808</li> -->
                                    </ul>
                                </div>





                            </div>



                        </div>




                    </div>
                    <!--/ Invoice Company Details -->

                    <!-- Invoice Customer Details -->
                    <div id="invoice-customer-details" class="row pt-2">
                        <div class="col-sm-12 text-left">
                            <p class="text-muted" style="font-size: x-large !important">To</p>
                        </div>
                        <div class="col-6 text-left" style="font-size:large">
                            <ul class="px-0 list-unstyled">
                                <li class="text-muted">{{model.customerFullName}}</li>
                                <div class="row">
                                    <div class="col-8">
                                        <p class="text-muted">
                                            {{model.customerAddress}}
                                            <br> {{model.customerContact}}
                                        </p>
                                    </div>
                                </div>
                                <li class="text-muted" *ngIf="model.customerGSTNO!=''">GST No: {{model.customerGSTNO}}</li>
                                <li class="text-muted" *ngIf="model.customerGSTNO==''">GST No: NA</li>

                            </ul>
                        </div>
                        <div class="col-6 text-right" style="margin-top: -2%;">
                            <ul class="px-0 list-unstyled" style="font-size: large">

                                <li><span class="text-muted">Date :</span>{{convertoshort(model.challanDate)}}</li>
                                <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Terms :</span> Due on Receipt</li> -->
                                <!-- <li *ngIf="model.balanceAmount!=0"><span class="text-muted">Due Date :</span> {{duedate(model.billDate)}}</li> -->
                            </ul>

                        </div>
                    </div>
                    <!--/ Invoice Customer Details -->

                    <!-- Invoice Items Details -->
                    <div id="invoice-items-details" class="pt-2">
                        <div class="row">
                            <div class="custoemPrintFont customePrint table-responsive col-sm-12 textclass">
                                <table class="custoemPrintFont table textclass">
                                    <thead>
                                        <tr>
                                            <th style="width: 10%;">#</th>
                                            <th style="width: 50%">Description</th>

                                            <th style="width: 38%;padding-left: 20rem;">Quantity</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr *ngFor="let obj of lstChallansItems; let i=index">
                                            <th scope="row">{{i+1}}</th>
                                            <td>
                                                <p>{{obj.challanItemNameDes}}.
                                                    <br><label style="font-style: italic">Code:{{obj.challanItemQrCode}} {{obj.challanItemSerialNo}}</label></p>
                                            </td>


                                            <td style="padding-left: 22rem;"> {{obj.challanItemQty}}</td>


                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="custoemPrintFont row textclass">

                            <div class="col-6">

                                <div style="margin-left: 6%;">
                                    <p alt="signature" class="height-100">Authorized person</p>
                                    <p>Signature</p>

                                </div>
                            </div>
                            <div class="custoemPrintFont col-6 text-right">

                                <div style="margin-right: 14%">
                                    <p alt="signature" class="height-100">Stamp</p>


                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <!-- Invoice Footer -->
                    <div id="invoice-footer">
                        <div class="custoemPrintFont text-center bot2">
                            <h3 style="font-weight:bold;">Thank You!</h3>
                        </div>
                        <div class="custoemPrintFont text-center bot3">
                            <p style="font-weight:bold;">Should you have any enquiries concerning this delivery, please contact: {{model.challanContactNo}}</p>
                        </div>

                        <div class="custoemPrintFont text-center bot4">
                            <p style="font-weight:bold;">Email:info@octaitsolution.com&nbsp;&nbsp;web:www.octaitsolution.com</p>
                        </div>
                    </div>
                    <!--/ Invoice Footer -->

                </div>
                <div class="row">
                    <div class="col-7 text-center">
                    </div>
                    <div class="col-5 text-center">
                        <button type="button" class="btn btn-info btn-lg my-1" (click)="getPrint('invoice-template')"><i class="la la-paper-plane-o"></i> Print
              </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>